import axios from "axios";
import { axiosInstance, getAPI, patchAPI, postAPI, putAPI } from "../utils/api";
import endpoints from "../utils/endpoints";

export const parseBrandsPageResponse = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;
  const content =
    payload?.content ||
    body?.content ||
    payload?.brands ||
    body?.brands ||
    [];

  const list = Array.isArray(content) ? content : [];

  return {
    content: list,
    totalElements:
      payload?.totalElements ?? body?.totalElements ?? list.length,
    totalPages: Math.max(payload?.totalPages ?? body?.totalPages ?? 1, 1),
    number: payload?.number ?? body?.number ?? 0,
    size: payload?.size ?? body?.size ?? list.length,
  };
};

export const getAllBrands = (payload, callBack, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: payload?.page ?? 0,
      size: payload?.size ?? payload?.perPage ?? 20,
      active:
        typeof payload?.active === "boolean" ? payload.active : undefined,
      brandType: payload?.brandType || undefined,
      provider: payload?.provider || undefined,
      search: payload?.search || payload?.searchText || undefined,
    };

    getAPI(
      endpoints?.GET_ALL_BRANDS,
      queryParams,
      (data) => {
        callBack({
          ...data,
          parsed: parseBrandsPageResponse(data),
        });
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem("token")
    );
  };
};

export const getTotalAmount = (callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints?.GET_VOUCHERS_TOTAL,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      }
    );
  };
};

export const getVouchersAndOrdersCount = (callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints?.GET_ALL_VOUCHERS_AND_ORDERS,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      }
    );
  };
};
export const normalizeFlipkartBalance = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;
  const clients = Array.isArray(payload?.clients) ? payload.clients : [];

  if (clients.length > 0) {
    const primaryClient = clients[0];
    const balance = clients.reduce(
      (sum, client) => sum + (Number(client?.balance) || 0),
      0
    );
    const discountPercentage = Number(
      primaryClient?.discountPercentage ?? primaryClient?.discount
    );

    return {
      balance,
      discountPercentage: Number.isFinite(discountPercentage)
        ? discountPercentage
        : 0,
      clients,
      clientName: primaryClient?.name ?? null,
      statusCode: payload?.statusCode,
      statusMessage: payload?.statusMessage,
    };
  }

  const legacyBalance =
    payload?.balance ??
    payload?.flipkartBalance ??
    payload?.amount ??
    payload?.flipkartAmount ??
    payload?.flipkart ??
    body?.balance;

  const parsedBalance = Number(legacyBalance);
  const legacyDiscount = Number(
    payload?.discountPercentage ??
      payload?.flipkartDiscount ??
      payload?.discount
  );

  return {
    balance: Number.isFinite(parsedBalance) ? parsedBalance : 0,
    discountPercentage: Number.isFinite(legacyDiscount) ? legacyDiscount : 0,
    clients: [],
    clientName: null,
    statusCode: payload?.statusCode,
    statusMessage: payload?.statusMessage,
  };
};

export const getFlipkartBalance = (callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints?.GET_FLIPKART_BALANCE,
      {},
      (data) => {
        callBack(normalizeFlipkartBalance(data));
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

/** @deprecated Use getFlipkartBalance */
export const getFlipkartCount = getFlipkartBalance;

export const normalizeWoohooBalance = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;

  const rawBalance =
    payload?.walletBalance ??
    payload?.balance ??
    payload?.amount ??
    payload?.availableBalance ??
    body?.walletBalance ??
    body?.balance;

  const parsedBalance = Number(rawBalance);

  return {
    balance: Number.isFinite(parsedBalance) ? parsedBalance : 0,
    statusCode: payload?.statusCode ?? body?.statusCode,
    statusMessage: payload?.statusMessage ?? body?.statusMessage,
  };
};

export const getWoohooWalletBalance = (callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints?.GET_WOOHOO_WALLET_BALANCE,
      {},
      (data) => {
        callBack(normalizeWoohooBalance(data));
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const normalizeGyftrBalance = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;

  const rawBalance =
    payload?.walletBalance ??
    payload?.balance ??
    payload?.availableBalance ??
    payload?.currentBalance ??
    payload?.current_balance ??
    payload?.WalletBalance ??
    payload?.Balance ??
    payload?.amount ??
    body?.walletBalance ??
    body?.balance ??
    body?.data?.balance;

  const parsedBalance = Number(rawBalance);

  return {
    balance: Number.isFinite(parsedBalance) ? parsedBalance : 0,
    statusCode: payload?.statusCode ?? body?.statusCode,
    statusMessage: payload?.statusMessage ?? body?.statusMessage,
  };
};

export const getGyftrWalletBalance = (callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints?.GET_GYFTR_WALLET_BALANCE,
      {},
      (data) => {
        callBack(normalizeGyftrBalance(data));
      },
      (err) => {
        if (typeof errorCallback === 'function') {
          errorCallback(err);
        }
      },
      localStorage.getItem('token')
    );
  };
};

export const normalizeHubbleBalance = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;

  const rawBalance =
    (typeof body === 'number' ? body : null) ??
    (typeof payload === 'number' ? payload : null) ??
    payload?.walletBalance ??
    payload?.balance ??
    payload?.availableBalance ??
    payload?.currentBalance ??
    payload?.current_balance ??
    payload?.WalletBalance ??
    payload?.Balance ??
    payload?.amount ??
    body?.walletBalance ??
    body?.balance ??
    body?.availableBalance ??
    body?.currentBalance ??
    body?.data?.balance ??
    body?.data?.walletBalance;

  const parsedBalance = Number(rawBalance);

  return {
    balance: Number.isFinite(parsedBalance) ? parsedBalance : 0,
    statusCode: payload?.statusCode ?? body?.statusCode ?? response?.status,
    statusMessage:
      payload?.statusMessage ?? body?.statusMessage ?? response?.statusText,
  };
};

export const getHubbleBalance = (callBack, errorCallback) => {
  return (dispatch) => {
    const apiKey =
      process.env.REACT_APP_HUBBLE_API_KEY ||
      process.env.REACT_APP_GIFT_CARD_API_KEY ||
      'B88KPrXHqO0BIHca1IsCifUc';

    const url =
      endpoints?.GET_HUBBLE_BALANCE ||
      'https://api.siripay.in/api/hubble/balance';

    axios
      .get(url, {
        headers: {
          'x-api-key': apiKey,
          Accept: 'application/json',
        },
      })
      .then((res) => {
        if (typeof callBack === 'function') {
          callBack(normalizeHubbleBalance(res));
        }
      })
      .catch((err) => {
        // Fallback to backend.siripay.co proxy if available
        const fallbackUrl = 'https://backend.siripay.co/api/hubble/balance';
        const token = localStorage.getItem('token');
        const fallbackHeaders = {
          'x-api-key': apiKey,
          Accept: 'application/json',
        };
        if (token) {
          fallbackHeaders.Authorization = `Bearer ${token}`;
        }

        axios
          .get(fallbackUrl, { headers: fallbackHeaders })
          .then((res) => {
            if (typeof callBack === 'function') {
              callBack(normalizeHubbleBalance(res));
            }
          })
          .catch((fallbackErr) => {
            if (typeof errorCallback === 'function') {
              errorCallback(fallbackErr || err);
            }
          });
      });
  };
};

export const getAllCategory = (callBack, errorCallback) => {
  return (dispatch) => {
    postAPI(
      endpoints?.GET_ALL_CATEGORY,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      }
    );
  };
};

export const bannerAdd = (id, payload, callBack, errorCallback) => {
  return (dispatch) => {
    postAPI(
      `${endpoints?.ADD_BANNER}/${id}`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      }
    );
  };
};
export const updateCategory = (id, payload, callBack, errorCallback) => {
  return (dispatch) => {
    patchAPI(
      `${endpoints?.UPDATE_CATEGORY}/${id}`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      }
    );
  };
};

export const updateBrand = (id, payload, callBack, errorCallback) => {
  return (dispatch) => {
    putAPI(
      `${endpoints?.UPDATE_BRAND}/${id}`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem("token")
    );
  };
};

export const updateBrandDiscount = (id, payload, callBack, errorCallback) => {
  return (dispatch) => {
    patchAPI(
      `${endpoints?.UPDATE_BRAND_DISCOUNT}/${id}/discount`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem("token")
    );
  };
};
export const uploadDocument = (payload, callBack, errorCallback) => {
  return (dispatch) => {
    postAPI(
      endpoints?.UPLOAD_FILE,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      }
    );
  };
};

export const exportAllBrands = (callBack, errorCallback) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    axiosInstance
      .get(endpoints.EXPORT_ALL_BRANDS, {
        responseType: "blob",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true,
      })
      .then((response) => {
        callBack(response);
      })
      .catch((error) => {
        errorCallback(error);
      });
  };
};

export const uploadBrandDiscount = (file, callBack, errorCallback) => {
  return (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("token");

    axiosInstance
      .post(endpoints.UPLOAD_BRAND_DISCOUNT, formData, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((response) => {
        callBack(response);
      })
      .catch((error) => {
        errorCallback(error);
      });
  };
};
